import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero, Reveal, GoldButton } from "@/components/bits/Reveal";
import { IMAGES, SERVICES } from "@/data/content";
import { useSEO } from "@/lib/seo";

export default function Services() {
  useSEO(
    "Our Services | Manpower Outsourcing, Contract Staffing & Recruitment — Maqline Solutions Pvt Ltd",
    "Maqline Solutions Pvt Ltd services: manpower outsourcing, contract staffing, recruitment & placement, internships, industrial training, apprenticeship hiring, workforce coordination and payroll support in Bengaluru."
  );

  return (
    <main data-testid="services-page">
      <PageHero
        overline="Our Services"
        titleLines={["Workforce solutions,", "explained properly."]}
        description="No vague promises. Here is exactly what each Maqline service covers, who it is for, and how it works."
        image={IMAGES.engineer}
      />

      <section className="bg-white py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {SERVICES.map((s, i) => (
              <Reveal key={s.slug} delay={(i % 4) * 0.08}>
                <Link
                  to={`/services/${s.slug}`}
                  data-testid={`service-card-${s.slug}`}
                  className="group flex flex-col bg-white border border-ink/10 hover:border-gold/50 rounded-sm p-7 h-full transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_18px_44px_rgba(6,27,58,0.1)]"
                >
                  <span className="font-mono text-sm text-gold font-bold">{s.num}</span>
                  <h2 className="font-display text-xl text-ink mt-4 mb-3 group-hover:text-navy transition-colors duration-300 leading-snug">{s.title}</h2>
                  <p className="text-[13px] text-muted leading-relaxed flex-1">{s.short}</p>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-xs font-bold text-navy group-hover:text-gold transition-colors duration-300 uppercase tracking-wider">
                    Open Service Page <ArrowRight size={13} className="group-hover:translate-x-1 transition-transform duration-300" />
                  </span>
                </Link>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.15}>
            <p className="text-center text-sm text-muted mt-12">Every service has its own detailed page — coverage, who it's for, and exactly how engagement works.</p>
          </Reveal>
        </div>
      </section>

      <section className="bg-darknavy noise-bg py-14 sm:py-20">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
          <div>
            <h2 className="font-display text-3xl text-white">Not sure which service fits?</h2>
            <p className="text-white/55 mt-2 text-sm max-w-md">Tell us your requirement — our team will recommend the right structure.</p>
          </div>
          <Link to="/contact" data-testid="services-contact-cta"><GoldButton gold>Talk to Our Team <ArrowRight size={15} /></GoldButton></Link>
        </div>
      </section>
    </main>
  );
}
